export default {
  default: () => import("/home/node/layouts/default.vue").then(m => m.default || m),
  "mobile-game-section": () => import("/home/node/layouts/mobileGameSection.vue").then(m => m.default || m)
}